<template>
  <section>
    <h1 class="has-text-weight-semibold">{{ heading }}</h1>
    <p>
      <slot />
    </p>
  </section>
</template>

<script>
export default {
  name: 'ParagraphWithHeader',
  props: {
    heading: {
      type: String,
      default: 'Header'
    }
  }
}
</script>

<style>

</style>
